export default __webpack_public_path__ + "static/media/hand-wash.5de6c700.jpg";